import { useSyncExternalStore } from 'react';
import { refreshAccessToken } from '../utils/refresh';

// « settled » : le boot a-t-il tranché l'auth (succès OU échec) ? One-way.
// La garde de route s'en sert pour patienter (skeleton) au lieu de rediriger
// vers /login pendant le silent refresh — sinon flash à chaque reload (G-02).
let settled = false;
const listeners = new Set<() => void>();

/**
 * Silent refresh unique au démarrage : ré-hydrate l'access token depuis le
 * cookie httpOnly après un reload (G-05). Échec avalé — on reste anonyme.
 */
export async function bootstrapAuth(): Promise<void> {
  try {
    await refreshAccessToken();
  } catch {
    // Pas de session → anonyme. refreshAccessToken a déjà purgé le token.
  } finally {
    if (!settled) {
      settled = true;
      for (const listener of listeners) listener();
    }
  }
}

export function isBootstrapSettled(): boolean {
  return settled;
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

function getServerSnapshot(): boolean {
  return false;
}

export function useBootstrapSettled(): boolean {
  return useSyncExternalStore(subscribe, isBootstrapSettled, getServerSnapshot);
}
